<template>
  <div v-if="fieldData.field_prepend" class="field-icon input-group-prepend">
    <div class="input-group-text qrp-input-icon-background">
      <icon :name="fieldData.field_prepend" scale=".6" class="d-block mx-auto"></icon>
    </div>
  </div>
</template>

<script>
export default {
  props: ['fieldData'],
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/presentational/FieldIcon.vue?5c894cce